<template src="./AppHeader-Checkout.html"></template>
<style lang='scss' scoped src="./AppHeader-Checkout.scss"></style>
<script>
import {
    SfImage,
} from '@storefront-ui/vue';

import {icons} from "@/utils/icons";

export default {
    name: 'AppHeaderCheckout',
    components: {
        SfImage,
    },
    data() {
        return {
            icons: icons,
            term: '',
            cartTotalItems: 0,
        };
    },
    computed: {
        /*  user: {
              get() {
                  return this.$store.getters.getProfile
              }
          },*/
        locale: {
            get() {
                return this.$i18n.locale
            }
        },
        /*isAuthenticated: {
            get() {
                return this.$store.getters.isAuthenticated
            }
        },*/
        /*   cart: {
               get() {
                   return this.$store.getters.getCart
               }
           }*/
    },

    mounted() {
        //this.$store.dispatch('getMe');
        //this.$store.dispatch('getCart');
    }
};
</script>


